import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import { getStorePerformances } from '../../actions/store-performance';
import { loadPageContent } from '../../actions/content';
import { getOutlets } from '../../actions/outlet';
import { getStorePerformanceObjectives } from '../../actions/store-performances-objectives';
import ObjectivePerformances from './objective-performances';
import UserPerformancesList from './user-performances-list';
import SearchableSelect from '../common/form/elements/searchable-select';
import { filterOptions, statusOptions } from './constants';

import './style.css';

export const pages = {
  stock_it: 'STOCK IT',
  display_it: 'DISPLAY IT',
  price_it: 'PRICE IT',
  sell_it: 'SELL IT',
  ngp: 'BLU BAR SELL IT'
};

class StorePerformance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeLink: '',
      openPanels: [],
      selectedOutlet: null,
      selectedFilter: { value: '0', label: 'All' },
      selectedStatus: { value: '1', label: 'Live' }
    };

    this.panelRefs = {};
  }

  pageSlug = 'store-performance';

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getStorePerformances());
    dispatch(getOutlets());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    window.addEventListener('scroll', this.handleScroll);
  }

  updateSelectedOutlet = () => {
    if (this.props.stores[0]) {
      this.setState({
        selectedOutlet: { value: this.props.stores[0].id, label: this.props.stores[0].attributes.name }
      }, () => {
        this.props.dispatch(getStorePerformanceObjectives(this.state.selectedOutlet.value));
      });
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.stores !== this.props.stores) {
      const rewardStores = this.props.stores.filter(store => store.attributes.reward === true);
      const outletOptions = rewardStores.map(store => (
        {
          value: store.id,
          label: store.attributes.name
        }
      ));

      this.setState({
        outletOptions
      }, () => {
        this.updateSelectedOutlet();
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handleClick = (key) => {
    if (this.state.openPanels.includes(key)) {
      this.setState({
        openPanels: this.state.openPanels.filter(panelKey => panelKey !== key),
        activeLink: ''
      });
    } else {
      this.setState({
        openPanels: [...this.state.openPanels, key],
        activeLink: key
      });
    }
  };

  handleScroll = () => {
    const activeLink = Object.entries(this.panelRefs).find(([, element]) =>
      element.getBoundingClientRect().bottom >= 50 &&
      element.getBoundingClientRect().top <= 70);
    this.setState({ activeLink: activeLink ? activeLink[0] : '' });
  };

  handleOutletChange = (event) => {
    this.setState({
      selectedOutlet: this.state.outletOptions.find(x => x.value === event)
    }, () => {
      this.props.dispatch(getStorePerformanceObjectives(this.state.selectedOutlet.value));
    });
  };

  handleFilterChange = (event) => {
    this.setState({
      selectedFilter: filterOptions.find(x => x.value === event)
    });
  };

  handleStatusChange = (event) => {
    this.setState({
      selectedStatus: statusOptions.find(x => x.value === event)
    });
  };

  render() {
    const { contents, area } = this.props;
    const { pageSlug, handleContentSaved } = this;

    const tabs = Object.entries(pages).map(([key, label], idx) =>
      (
        <li key={idx}>
          <a
            href={`#${key}`}
            className={this.state.activeLink === key ? 'panel-active' : ''}
            id={`${key}-link`}
            onClick={() => this.handleClick(key)}
          >
            {label}
          </a>
        </li>
      ));

    return (
      <Grid bsClass="container" className="store-performance user-inner-container">
        <Row>
          <Col className="store-performance-title" lg={12}>
            <PageTitle>
              Store Performance
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              contents={contents[`${pageSlug}_content_text`]}
              identifier={`${pageSlug}_content_text`}
              onContentSaved={handleContentSaved}
            />
          </Col>
        </Row>
        {(area === 'retailer') && (
          <Row className="store-performance-filter">
            <Col md={4}>
              <SearchableSelect
                label='Outlet'
                model='deep.submission.outlet_id'
                options={this.state.outletOptions}
                value={this.state.selectedOutlet}
                onChange={e => this.handleOutletChange(e)}
              />
            </Col>
            <Col md={4}>
              <SearchableSelect
                label='Filter'
                model='deep.submission.filter'
                options={filterOptions}
                value={this.state.selectedFilter}
                onChange={e => this.handleFilterChange(e)}
              />
            </Col>
            <Col md={4}>
              <SearchableSelect
                label='Status'
                model='deep.submission.status'
                options={statusOptions}
                value={this.state.selectedStatus}
                onChange={e => this.handleStatusChange(e)}
              />
            </Col>
          </Row>
         )}
        {(area !== 'retailer') && (
          <Row style ={{ marginBottom: '20px' }}>
            <Col lg={12}>
              <ul id="performances-menu">{tabs}</ul>
            </Col>
          </Row>
        )}
        {(area === 'retailer') && (
          <UserPerformancesList
            filter={this.state.selectedFilter}
            status={this.state.selectedStatus}
          />
        )}
        {(area !== 'retailer') && (
          <ObjectivePerformances
            pages={pages}
            panelRefs={this.panelRefs}
            openPanels={this.state.openPanels}
            handleClick={this.handleClick}
          />
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.stores.fetching && !state.stores.fetched,
  performances: state.stores.performances,
  contents: state.content.list,
  stores: state.stores.stores,
});

export default connect(mapStateToProps)(StorePerformance);



// WEBPACK FOOTER //
// ./src/components/store-performance/index.jsx